module.exports = __webpack_public_path__ + "static/media/priyanshi_arora.393dcec8.jpeg";